export class AuditTriggerLogs {
  id?: number;
  operationName: string;
  operationTime: Date;
  tableName: string;
  logType: string;
  entityId: string;
  userId: string;
  actor?: string;
  before?: object;
  after?: object;
  dateString?: string;
  timeOfCreation?: string;
}
